import React, { SVGProps } from 'react';
const arrowDownFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M9.333 12.667 16 19.334l6.667-6.667z" /></svg>;
export default arrowDownFilled;